import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ContenedorComponent } from './components/contenedor/contenedor.component';
import { CambiarPassComponent } from './components/cambiar-pass/cambiar-pass.component';
import { AutenticacionComponent } from './components/autenticacion/autenticacion.component';
import { MenuComponent } from './components/menu/menu.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';

const routes: Routes = [
	{
        path: 'habilitar-cuenta', 
        component: ContenedorComponent,      
        children: [
            { path: '', redirectTo: 'autenticacion', pathMatch:'full' },
            { path: 'autenticacion', component: AutenticacionComponent },   
            { path: 'menu', component: MenuComponent },
            { path: 'confirmacion', component: ConfirmacionComponent },
            { path: 'cambiar-pass', component: CambiarPassComponent },

        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HabilitarCuentaRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/habilitar-cuenta-routing.module.ts